import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FieldGroup, Loader } from '@itds/elements/index.js';
import { CarrierCard } from '@itds/components/index.js';

import { Api } from '@brokerage/utils/Api';

const LimitCarriers = ({ mobile_app, updateAgencyMobileApp }) => {
  const [data, setData] = useState({
    carrier_ids: mobile_app.carrier_ids || [],
    product_ids: mobile_app.product_ids || []
  });
  const [product_ids, setProductIds] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [carrier_ids, setCarrierIds] = useState([]);
  const [agency_specific_carriers, setAgencySpecificCarriers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    getData();
  }, []);

  useEffect(() => {
    setData({
      carrier_ids: mobile_app.carrier_ids || [],
      product_ids: mobile_app.product_ids || []
    });
  }, [mobile_app]);

  const getData = () => {
    Promise.all([Api.loadLifeCarriers(), Api.loadAgencySpecificCarriers()]).then(response => {
      const carriers = response[0].data;
      const agency_specific_carriers = response[1].data;

      setCarriers(carriers);
      setCarrierIds(carriers.map(c => c.id));
      setProductIds(carriers.map(c => c.products.map(p => p.id)).flat());
      setAgencySpecificCarriers(agency_specific_carriers);
      setLoading(false);
    });
  };

  const handleSelectAll = () => {
    if (data.carrier_ids.length !== carrier_ids.length) {
      setData({
        product_ids,
        carrier_ids
      });
    } else {
      setData({ product_ids: [], carrier_ids: [] });
    }
  };

  const handleCarrierToggle = (carrier, checked) => {
    const is_selected = !checked;
    const carrier_product_ids = carrier.products.map(p => p.id);

    let selected_carrier_ids = [...data.carrier_ids];

    let selected_product_ids = [...data.product_ids];

    if (is_selected) {
      selected_carrier_ids.push(carrier.id);
      selected_product_ids = data.product_ids.concat(carrier_product_ids);
    } else {
      selected_carrier_ids = data.carrier_ids.filter(id => id !== carrier.id);
      selected_product_ids = data.product_ids.filter(id => !carrier_product_ids.includes(id));
    }

    setData({
      carrier_ids: selected_carrier_ids,
      product_ids: selected_product_ids
    });
  };

  const handleProductsChange = product_ids => {
    setData({ ...data, product_ids });
  };

  const save = data => {
    updateAgencyMobileApp(data);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div style={{ marginBottom: '30px' }}>
        <Button inline={true} onClick={handleSelectAll.bind(null)} small={true}>
          {data.carrier_ids.length === carrier_ids.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {carriers.map(carrier => {
              const is_selected = data.carrier_ids.includes(carrier.id);

              return (
                <CarrierCard
                  carrier={carrier}
                  isSelected={is_selected}
                  key={carrier.id}
                  onClick={handleCarrierToggle.bind(null, carrier, is_selected)}
                  onProductsSave={handleProductsChange.bind(null)}
                  products={carrier.products}
                  selectedProductIds={data.product_ids}
                />
              );
            })}
          </div>

          <br />
          <FieldGroup contained={true} label='Agency Specific Carriers'>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {agency_specific_carriers.map(carrier => {
                const is_selected = data.carrier_ids.includes(carrier.id);

                return (
                  <CarrierCard
                    carrier={carrier}
                    isSelected={is_selected}
                    key={carrier.id}
                    onClick={handleCarrierToggle.bind(null, carrier, is_selected)}
                    onProductsSave={handleProductsChange.bind(null)}
                    products={carrier.products}
                    selectedProductIds={data.product_ids}
                  />
                );
              })}
            </div>
          </FieldGroup>

          <Button inline={true} onClick={save.bind(null, data)}>
            Save Changes
          </Button>
        </>
      )}
    </>
  );
};

LimitCarriers.propTypes = {
  mobile_app: PropTypes.object,
  updateAgencyMobileApp: PropTypes.func
};

export default LimitCarriers;
